<template>
  <div class="mit-manage-borrowed-page mit-page">
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Manage Borrowed</v-card-title>
            <v-card-subtitle class="caption">Managing the list of borrowed keys</v-card-subtitle>
            <v-divider></v-divider>
            <MitBorrowedList></MitBorrowedList>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import {MitEventBus} from '../../main.js';
  import MitBorrowedList from '../../components/borrowed/MitBorrowedList.vue';


  export default {
    name: 'MitManageBorrowedPage',
    components: {
      MitBorrowedList
    },
    data: function() {
      return {
      }
    },
    mounted() {

    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
